import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const dpeSubscriptionVendingPlugin = createPlugin({
  id: 'dpe-subscription-vending',
  routes: {
    root: rootRouteRef,
  },
});

export const DpeSubscriptionVendingPage = dpeSubscriptionVendingPlugin.provide(
  createRoutableExtension({
    name: 'DpeSubscriptionVendingPage',
    component: () => import('./components/SubscriptionVending').then((m) => m.SubscriptionVending),
    mountPoint: rootRouteRef,
  }),
);
